import mapJson from '@/tool/chinaMap_new.json'
import axios from 'axios'

const global = {
  fixedHead: function(e) {
    let obj = $(e.target);
    obj.find('table thead').css('transform', 'translateY(' + (obj.scrollTop() - 1) + 'px)');
  },
  picUrl: '',
  ossUrl: 'https://yaling-system.oss-cn-shenzhen.aliyuncs.com/client_clinic/',

  showImg(e) {
    if (e.path != undefined) {
      e.path[0].classList = [];
      let _w = e.path[0].naturalWidth,
        _h = e.path[0].naturalHeight,
        _parentW = e.path[1].clientWidth,
        _parentH = e.path[1].clientHeight,
        _small = parseFloat(_w / _h).toFixed(2),
        _big = parseFloat(_parentW / _parentH).toFixed(2);
      if (_w < _parentW || _h < _parentH) { //原始图小于展示区域
        if (_w < _parentW) { //宽小于
          if (_w > _h && _h < _parentH) { //宽高都小于
            e.path[0].classList.add('imgMinHeight');
          } else {
            e.path[0].classList.add('imgMinWidth');
          }
        } else { //高小于
          e.path[0].classList.add('imgMinHeight');
        }
      } else { //原始图大于展示区域
        if (_small >= _big) {
          e.path[0].classList.add('imgMaxHeight');
        } else {
          e.path[0].classList.add('imgMaxWidth');
        }
      }
    } else { //兼容IE
      e.target.className = '';
      console.log(e.target.className)
      let _w = e.target.naturalWidth,
        _h = e.target.naturalHeight,
        _parentW = e.target.parentNode.clientWidth,
        _parentH = e.target.parentNode.clientHeight,
        _small = parseFloat(_w / _h).toFixed(2),
        _big = parseFloat(_parentW / _parentH).toFixed(2);
      if (_w < _parentW || _h < _parentH) { //原始图小于展示区域
        if (_w < _parentW) { //宽小于
          if (_w > _h && _h < _parentH) { //宽高都小于
            e.target.className = 'imgMinHeight';
          } else {
            e.target.className = 'imgMinWidth';
          }
        } else { //高小于
          e.target.className = 'imgMinHeight';
        }
      } else { //原始图大于展示区域
        if (_small >= _big) {
          e.target.className = 'imgMaxHeight';
        } else {
          e.target.className = 'imgMaxWidth';
        }
      }
    }
  },

  notFind: function(e, size) {
    e.target.src = '/static/img/patient' + size + '.png';
  },
  notGoodsImg: function(e) {
    let src = '/static/img/default.png';
    e.target.src = src;
  },
  //无产品图片
  notProdoctImg: function(e) {
    let src = '/static/img/productIcon.png';
    e.target.src = src;
  },
  /*获取上传图片必要信息 type图片类型,文件*/
  /* type=>上传的图片类型 只允许 1,2,3,4,5。 1、医生头像 2、病人头像 3、诊所图像 4、患者影像 5、诊所认证图像   */
  //watermark 是水印
  getuploadsign: function(type, file, watermark, percentCallback) {
    let params = {
      type: type,
      watermark: watermark
    }
    // if (type == 8) {
    //   params.is_dx_modify = 1;
    //   params.dx_suffix  = 'png'
    // }
    return new Promise((resolve, reject) => {
      axios.get('/getuploadsign', {
        params: params
      }).then(res => {
        if (res.code != 1) {
          return;
        }
        let data = {};
        data.imgServer = res.data.host;
        data.OSSAccessKeyId = res.data.access_id;
        data.policy = res.data.policy;
        data.signature = res.data.signature;
        data.callback = res.data.callback;
        data.path = res.data.dir;
        data.name = res.data.md5_key;
        data.watermark = res.data.watermark
        data.file = file;
        this.uploadImg(data, percentCallback).then(res => {
          resolve({
            res: res,
            url: data.imgServer + '/' + data.path + data.name + data.watermark
          });
        });
      }).catch(err => {
        reject(err);
      })
    });

  },
  updateAllData: function() {
    this.$root.$children[0].reload()
  },
  /*上传图片*/
  uploadImg: function(data, percentCallback) {
    let fd = new FormData();
    fd.append('Content-Length', Math.round(data.file.size * 100 / 1024) / 100);
    fd.append('OSSAccessKeyId', data.OSSAccessKeyId);
    fd.append('policy', data.policy);
    fd.append('signature', data.signature);
    fd.append('callback', data.callback);
    fd.append('key', data.path + data.name); //文件名字
    fd.append('success_action_status', '200');
    fd.append('file', data.file); //文件必须声明在最后，否则异常
    return new Promise((resolve, reject) => {
      axios.post(data.imgServer, fd, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest: function(data) {
          return data;
        },
        onUploadProgress: function(progressEvent) { //原生获取上传进度的事件
          if (progressEvent.lengthComputable) {
            //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
            //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
            typeof percentCallback == 'function' && percentCallback(progressEvent);
          }
        }
      }).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  },

  reg: {
    empty: /^\s*$/,
    phone: /^((13[0-9])|(14[4-9])|(15[0-3,5-9])|(17[0-8])|(18[0-9])|(16[2,5-7])|(19[0-9]))\d{8}$/,
    chinese: /^[\u4E00-\u9FA5]+$/,
    nochinese: /^[^\u4e00-\u9fa5]{0,}$/, //不能出现中文
    noNumber: /^[0-9\u4e00-\u9fa5]+$/, //无数字
    name: /^[\u4E00-\u9FA5A-Za-z0-9]+$/,
    Num: /^[1-9][0-9]*$/,
    expressno: /^[0-9a-zA_Z]+$/, //物流单号
    licenseno: /^[0-9a-zA-Z]*$/, //许可证号 只能是字母或数字
    price: /^\d+(\.{0,1}\d+){0,1}$/ // 只能是正数
  },

  copy: function(obj) {
    let res = JSON.parse(JSON.stringify(obj));
    return res;
  },

  isArray: function(arr) {
    return (Object.prototype.toString.call(arr) == '[object Array]');
  },
  sameYear: function(time) {
    return moment(time).format('YYYY') == moment(new Date()).format('YYYY');
  },
  /* base64转blob */
  dataURLtoBlob: function(dataurl) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    });
  },
  getAllAttr(obj, key, type) {
    let style;
    if (window.getComputedStyle) {
      style = window.getComputedStyle(obj, null);
    } else {
      style = obj.currentStyle; // IE
    }
    if (key) {
      if (type) {
        return parseInt(style[key]);
      }
      return style[key];
    } else {
      return style;
    }
  },

  //校验数字,on-input
  Verify: function(val, type) {
    let v = String(val);
    let re = '';
    let reg = /^[0-9]+$/;
    switch (type) {
      case 'count':
        if (v.indexOf('0') == 0 && v.length > 0) {
          v = v.slice(1);
        } else if (v.match(reg) == null) {
          v = v.slice(0, -1)
        }
        re = v;
        break;
      case 'discount':
        if (val > 100) {
          re = 100;
        } else {
          if (v.indexOf('0') == 0 && v.length > 1) {
            v = v.slice(1);
          } else if (v.match(reg) == null) {
            v = v.slice(0, -1)
          }
          re = v;
        }
        // if(!Number(v)){
        //     v=100
        // }
        break;
      case 'money':
        v = v.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
        v = v.replace(/^\./g, ""); //验证第一个字符是数字
        v = v.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
        v = v.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        v = v.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
        re = v;
        break;
    }
    return re;
  },
  mapJson: mapJson,
  /**
   * 动态添加JS
   * @param src js地址
   * @param exist JS加载过的标识 如: jquery => $, loadsh => _
   * loadJs('https://cdn.bootcss.com/jquery/3.3.1/jquery.min.js', $).then($ => {})
   */
  loadJs(src, exist, id) {
    return new Promise((resolve, reject) => {
      if (exist) {
        resolve(exist);
      } else {
        let script = document.createElement('script');
        script.setAttribute('src', src);
        id && script.setAttribute('id', id);
        script.onload = function() {
          resolve(exist);
        };
        script.onerror = function(err) {
          reject(`${src}加载失败`, err);
        };
        document.getElementsByTagName("body")[0].appendChild(script);
      }
    });
  },
  // dx 上传
  // type
  getDxuploadsign: function(paramsData = {}, file, watermark, percentCallback) {
    let params = Object.assign({
      // type: type,
      watermark: watermark
    }, paramsData)
    // if (type == 8) {
    //   params.is_dx_modify = 1;
    //   params.dx_suffix  = 'png'
    // }
    return new Promise((resolve, reject) => {
      axios.get('/getuploadsign', {
        params: params
      }).then(res => {
        if (res.code != 1) {
          return;
        }
        let data = {};
        data.imgServer = res.data.host;
        data.OSSAccessKeyId = res.data.access_id;
        data.policy = res.data.policy;
        data.signature = res.data.signature;
        data.callback = res.data.callback;
        data.path = res.data.dir;
        data.name = res.data.md5_key;
        data.watermark = res.data.watermark
        data.file = file;
        this.uploadImg(data, percentCallback).then(res => {
          resolve({
            res: res,
            url: data.imgServer + '/' + data.path + data.name + data.watermark
          });
        });
      }).catch(err => {
        reject(err);
      })
    });
  }
};
export default global;



// WEBPACK FOOTER //
// ./src/tool/global.js